import { getDaysHoursMinsFromDateNumeric } from './get-days-hours-mins-from-date';

export const getDateOptionLabel = (date: number) => {
  const dateNumberStats = getDaysHoursMinsFromDateNumeric(date);
  const hours = dateNumberStats.hours;
  const minutes = dateNumberStats.minutes;

  return `${hours % 12 || 12}:${minutes < 10 ? '0' + minutes : minutes} ${hours >= 12 ? 'PM' : 'AM'}`;
};
